import { NgModule } from '@angular/core';
import { GalaxyListContainerComponent } from './list-container.component';
import { GalaxyListItemComponent, GalaxyListItemIconDirective } from './list-item.component';
import { GalaxyListNavItemComponent } from './list-nav-item.component';
import { GalaxySublistComponent, GalaxySublistContentDirective } from './sublist.component';

const COMPONENTS = [
  GalaxySublistComponent,
  GalaxySublistContentDirective,
  GalaxyListContainerComponent,
  GalaxyListItemComponent,
  GalaxyListNavItemComponent,
  GalaxyListItemIconDirective,
];

/**
 * Module provided for convenience to import all Galaxy Sublist components at once.
 */
@NgModule({
  imports: COMPONENTS,
  exports: COMPONENTS,
})
export class GalaxyListModule {}
